import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'

const Accelerate = () => {
    return (
        <>
            {/* Accelerate cloud */}
            <section className="accelerate-cloud-three mt-5">
                <div className="container">
                    {/* <div className="shapes-three-left">
                        <ImageWithBasePath
                            className="accelerate-three"
                            src="assets/img/shapes/shape-8.png"
                            alt="Img"
                        />
                        <ImageWithBasePath
                            className="accelerate-five"
                            src="assets/img/shapes/shape-9.png"
                            alt="Img"
                        />
                    </div> */}
                    {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>GROWTH</h4>
                                    <h2 className="text-skyblue my-4">
                                        Accelerate Growth, Amplify Results
                                    </h2>
                                    <p className="text-white mb-4">
                                       Gain access to personalized support that puts your institution in front of the right students. As a Growth Partner, boost qualified applications by 90%+ and increase final offers by over 180%.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4 z-1"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5 z-1"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2 z-1"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1 z-2 position-relative"
                                        src="assets/img/home-5/gallery-8.jpg"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                    {/* development-carrer*/}
                    <div className="development-carrer">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4 z-1"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5 z-1"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2 z-1"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1 z-2"
                                        src="assets/img/home-5/section-img-02.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-6.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/winning.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>EXPERTISE</h4>
                                    <h2 className="text-success my-4">
                                        Harness Global Intelligence to Drive Smarter Decisions
                                    </h2>
                                    <p className="text-white mb-4">
                                        Backed by millions of data points and a seasoned strategy team, gain powerful insights, stay ahead of trends, and ensure trusted recruitment through rigorous vetting and compliance support.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /development-carrer */}
                    {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>EFFICIENCY</h4>
                                    <h2 className="text-skyblue my-4">
                                        Maximize Results, Minimize Effort
                                    </h2>
                                    <p className="text-white mb-4">
                                       Let automation and quality control do the heavy lifting—receive only complete, vetted applications so your team can focus on what matters most: growth and strategy.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/home-5/section-img-04.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                    {/* development-carrer*/}
                    <div className="development-carrer">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/home-5/section-img-01.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-6.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/winning.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>EXCELLENCE</h4>
                                    <h2 className="text-success my-4">
                                        Turn High-Caliber Leads into Future-Ready Graduates
                                    </h2>
                                    <p className="text-white mb-4">
                                        Connect with motivated, qualified students through a platform designed to meet your enrolment, revenue, and diversity targets—all while maintaining academic excellence.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /development-carrer */}
                     {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>Visibility</h4>
                                    <h2 className="text-skyblue my-4">
                                        Expand Your Global Footprint Across 150+ Markets
                                    </h2>
                                    <p className="text-white mb-4">
                                       Showcase your institution to a worldwide network of trusted recruitment partners and driven students—instantly connecting your programs to top talent from over 150 countries.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1 h-400 w-300"
                                        src="assets/img/home-5/event-01.jpg"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                </div>
            </section>
            {/* Accelerate cloud */}
        </>

    )
}

export default Accelerate
